// @flow
import { handleActions } from 'redux-actions';
import type { ActionType } from 'redux-actions';
import types from './types';
import typeof { fetchDataSuccess } from './actions';
import { deselect, select } from '../../TicketList/duck/actions';

export type State = {
    data: Array<number>,
    drawerOpen: boolean,
    fetching: boolean,
    metadata: Object,
    selected: number[],
};

export const init: State = {
    data: [],
    drawerOpen: false,
    fetching: true,
    metadata: {},
    selected: [],
};

export default handleActions({
    [types.FETCH_DATA]: (state: State) => ({
        ...state,
        fetching: true,
    }),
    [types.FETCH_DATA_ERROR]: (state: State) => ({
        ...state,
        fetching: false,
    }),
    [types.FETCH_DATA_SUCCESS]: (state: State, action: ActionType<fetchDataSuccess>) => ({
        ...state,
        data: action.payload,
        fetching: false,
        metadata: action.meta,
    }),
    [types.SELECT]: (state: State, action: ActionType<select>) => {
        const { selected } = state;
        const id = action.payload;

        return !selected.includes(id)
            ? { ...state, selected: [...selected, id] }
            : state;
    },
    [types.DESELECT]: (state: State, action: ActionType<deselect>) => ({
        ...state,
        selected: state.selected.filter((id: number): boolean => id !== action.payload),
    }),
    [types.DESELECT_ALL]: (state: State) => ({
        ...state,
        selected: [],
    }),
    [types.TOGGLE_FILTER_DRAWER]: (state: State, action: ActionType<*>) => ({
        ...state,
        drawerOpen: action.payload,
    }),
}, init);
